<template>
  <form class="user-form">
    <b-field label="Email">
      <b-input type="email" maxlength="128" v-model="email" />
    </b-field>
    <b-field label="Password">
      <b-input maxlength="20" minlength="8" type="password" v-model="password"></b-input>
    </b-field>
    <b-button type="is-success" @click="submit">Login</b-button>
    <p v-if="error" class="error">{{errorMsg}}</p>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import { authenticate } from "../api/methods";

const isAdminRole = (roleKey) => {
  switch (roleKey) {
    case "admin":
    case "selector":
    case "remote_selector":
      return true;
    default:
      return false;
  }
}

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      error: false,
      errorMsg: ""
    };
  },
  computed: {
    ...mapGetters(["snippets"])
  },
  methods: {
    submit() {
      this.error = false;
      this.errorMsg = "";
      if (this.email.length > 5 && this.password.length > 7) {
        authenticate(this.email, this.password).then(data => {
          let success = false;
          if (data.valid && data.active) {
            if (isAdminRole(data.role)) {
              success = true;
              this.$ls.set("user", data);
              this.$parent.setUser(data);
              const { path } = this.$route;
              const tgPath =
                data.role === "admin" ? "/submissions" : "/review";
              if (path !== tgPath) {
                this.$router.push(tgPath);
              }
            }
          }
          if (!success) {
            this.error = true;
            if (!data.valid && data.msg) {
              this.errorMsg = data.msg;
            } else {
              this.errorMsg = "Please check your user name and password";
            }
          }
        });
      }
    }
  }
};
</script>
